import { observer } from 'mobx-react-lite';
import { Suspense, SyntheticEvent, useState } from 'react';
import {
  Card,
  Header,
  Grid,
  Icon,
  Segment,
  Form,
  Input,
  Button,
} from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { v4 as uuid } from 'uuid';
import WorkflowTasks from './WorkflowTasks';
import { Template, elementTypes } from '../../../app/models/template';
import {
  cardcolor,
  errorEmptyText,
  errorMessageText,
  selectionEmptyErrorMsg,
} from '../../../app/common/form/errorMessageText';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import DeleteModal from '../../../library/deleteModal';

const cardStyleLevel4 = {
  display: 'inline-block',
  padding: '10px',
  height: '77vh',
  width: '200pt',
  marginLeft: '2px',
  marginTop: '55px',
  color: 'black',
  cursor: 'pointer',
  boxShadow: '5px 5px 10px lightgray',
  alignItems: 'center',
};
function WorkflowTemplates() {
  const {
    TemplateStore,
    workflowConfigurationStore,
    activityStore,
    RolesAndPermissionsIDStore,
    userStore,
    commonStore,
  } = useStore();
  const { loadTemplateById } = TemplateStore;
  const {
    selectedElementTypes,
    selectedTemplate,
    loadingInitialTemp,
    deleteTemplateType,
    createTemplateUnderElementType,
    UpdateTemplate,
    cloneTemplate,
  } = TemplateStore;
  const [getnewkey, setgetnewkey] = useState<number | null>();
  const [templateNew, setTemplateNew] = useState('');
  const [errorType, setErrorType] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteOption, setDeleteOption] = useState<Template>({
    templateId: '',
    templateName: '',
    templateDateTime: '',
    templateIndex: 0,
    isActive: false,
    isDeleted: false,
    tasks: [],
  });

  //  useEffect(() => { if (templateRegistry.size <= 1) loadTemplates(); }, [templateRegistry.size, loadTemplates]);
  const handleTemplateJSX = (id: string) => {
    if (
      workflowConfigurationStore.WorkflowConfiguration.disableClick === false
    ) {
      setErrorType('');
      loadTemplateById(id); //load template by id
      workflowConfigurationStore.setShowTemplateName(id); //show template name card
      workflowConfigurationStore.setShowTaskCard(true); //show task card
    }
    workflowConfigurationStore.setShowSubTaskCard(false);
    workflowConfigurationStore.setShowElementCard(false);

    //ResetEdit
    workflowConfigurationStore.resetEditClickedButtonExceptTemplate();
  };
  /////////////////this function to handle when Enter Key is pressed
  const handleKeyPress = (e: any) => {
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedTemplate ===
        false
    ) {
      addNewTemplate();
    }
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedTemplate ===
        true
    ) {
      handleSaveEdited('edit');
    }
  };

  const handleChangeName = (e: SyntheticEvent, data: any) => {
    setTemplateNew(data.value);
    const NameCheck = selectedElementTypes?.templateTypes.some(function (el) {
      function ciEquals(a: string, b: string) {
        return typeof a === 'string' && typeof b === 'string'
          ? a.trim().localeCompare(b, undefined, {
              sensitivity: 'accent',
            }) === 0
          : a === b;
      }
      return ciEquals(el.templateName, data.value);
    });
    setErrorType(NameCheck ? 'SameName' : ''); //check name exists
  };
  const addNewTemplate = () => {
    if (selectedElementTypes !== undefined && templateNew.length !== 0) {
      const templates = selectedElementTypes?.templateTypes;
      const ID = uuid();
      const newArr = {
        templateId: ID,
        templateName: templateNew,
        templateDateTime: activityStore.updateDateTime(),
        templateIndex: templates.length === 0 ? 0 : templates.length + 1,
        isActive: true,
        isDeleted: false,
        tasks: [],
      };
      //For roles and permissions
      const newRoleArr = {
        id: uuid(),
        itemId: ID,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };
      // for backend
      const selectedElementTypesArr = {
        ...selectedElementTypes,
        templateTypes: [newArr],
      };
      // for front end schema
      templates.push(newArr);
      const AllvaluefrontEndData = {
        ...selectedElementTypes,
        templateTypes: templates,
      };
      //set value to empty
      createTemplateUnderElementType(
        selectedElementTypesArr,
        AllvaluefrontEndData,
      );
      sendRespectiveEmail(
        'created',
        newArr.templateName,
        'Created Template',
        '',
      ); //email Function
      RolesAndPermissionsIDStore.createRoleID(newRoleArr); //roles and permissions
    } else {
      setErrorType('EmptyName');
    }
    setTemplateNew('');
  };
  // cloning
  const handleClone = () => {
    let flag = 0;
    selectedElementTypes?.templateTypes?.forEach((data) => {
      if (data.templateId === selectedTemplate?.templateId) {
        flag = 1;
      }
    });
    if (
      selectedElementTypes &&
      selectedTemplate !== undefined &&
      templateNew.length > 0 &&
      flag
    ) {
      cloneTemplate({
        id: selectedElementTypes.id,
        cloned_from: selectedTemplate.templateId,
        cloned_as: templateNew,
      });
      sendRespectiveEmail('cloned', templateNew, 'Cloned Template', ''); //email Function
    } else if (!flag) {
      setErrorType('selectionEmpty');
    } else if (templateNew.length === 0) {
      setErrorType('EmptyName');
    }
    setTemplateNew('');
  };
  //////////////////////edit clicked
  const handleEdit = (template: Template) => {
    setErrorType('');
    loadTemplateById(template.templateId);
    setTemplateNew(template.templateName);
    workflowConfigurationStore.setEditClickedTemplate(true);
  };
  ////////////////////////////save edited
  const handleSaveEdited = (name: string) => {
    if (
      selectedElementTypes &&
      selectedTemplate !== undefined &&
      name === 'edit'
    ) {
      const newArr = {
        ...selectedTemplate,
        templateName: templateNew,
      };
      UpdateTemplate(newArr);
      sendRespectiveEmail('edited', newArr.templateName, 'Edited Template', ''); //email Function
      //to update dom
      const data = selectedElementTypes?.templateTypes;
      const index = data.findIndex(
        (obj) => obj.templateId === selectedTemplate.templateId,
      );
      data[index].templateName = templateNew;
    }
    setTemplateNew('');
    workflowConfigurationStore.setEditClickedTemplate(false);
  };
  //////////////////////delete
  const handleDelete = (template: Template) => {
    if (selectedElementTypes !== undefined) {
      setErrorType('');
      setIsModalOpen(true);
      setDeleteOption(template);
    }
  };

  const deleteConfirmed = () => {
    const TemplateJSXs = selectedElementTypes?.templateTypes;

    const templateArr = {
      ...deleteOption,
      isDeleted: true,
    };
    //  const frontEndArr to show Delete
    const filterData =
      TemplateJSXs !== undefined
        ? TemplateJSXs.filter(
            (item) => item.templateId !== deleteOption.templateId,
          )
        : [];
    const AllvaluefrontEndData = {
      ...selectedElementTypes,
      templateTypes: filterData,
    };
    deleteTemplateType(templateArr, AllvaluefrontEndData as elementTypes);
    sendRespectiveEmail(
      'deleted',
      templateArr.templateName,
      'Deleted Template',
      '',
    ); //email Function
    setIsModalOpen(false);
  };

  const TemplateJSX = (
    <Card className="workflow-config-elements">
      {selectedElementTypes?.templateTypes.map((templates, index) => (
        <Card.Content
          key={index}
          onMouseEnter={() => setgetnewkey(index)}
          onMouseLeave={() => setgetnewkey(null)}
          style={
            templates.templateId ===
            workflowConfigurationStore.WorkflowConfiguration.showTemplateName
              ? cardcolor
              : null
          }
          onClick={() => handleTemplateJSX(templates.templateId)}
        >
          <Grid className="hoverColor" columns={3}>
            <Grid.Row columns={2}>
              <Grid.Column width={12}>{templates.templateName}</Grid.Column>

              <Grid.Column
                width={1}
                onMouseEnter={() =>
                  workflowConfigurationStore.setDisableClick(true)
                }
                onMouseLeave={() =>
                  workflowConfigurationStore.setDisableClick(false)
                }
              >
                {getnewkey === index ? (
                  <Icon
                    style={{ fontSize: '13px' }}
                    name="pencil"
                    color="grey"
                    size="small"
                    onClick={() => handleEdit(templates)}
                  />
                ) : null}
              </Grid.Column>
              <Grid.Column
                width={1}
                onMouseEnter={() =>
                  workflowConfigurationStore.setDisableClick(true)
                }
                onMouseLeave={() =>
                  workflowConfigurationStore.setDisableClick(false)
                }
              >
                {getnewkey === index ? (
                  <Icon
                    style={{ fontSize: '13px' }}
                    name="trash"
                    color="grey"
                    size="small"
                    onClick={() => handleDelete(templates)}
                  />
                ) : null}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      ))}
    </Card>
  );

  return (
    <div>
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
            }}
            deleteHandler={deleteConfirmed}
            header={'Delete'}
            text={
              'Are you sure you want to delete this? Deleting it will also remove all related data.'
            }
          />
        </Suspense>
      )}
      <Grid>
        <Card style={cardStyleLevel4}>
          <>
            <Header
              style={{ marginLeft: '20px' }}
              size="huge"
              as="h1"
              content="template/preset"
              sub
              color="grey"
            />
            {!selectedElementTypes || loadingInitialTemp ? (
              <LoadingComponent />
            ) : (
              TemplateJSX
            )}
          </>
          <Segment className="workflow-bottom-card">
            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  id="form-input-control-error-email"
                  className=" workflow-input"
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : errorType === 'selectionEmpty'
                          ? selectionEmptyErrorMsg
                          : null
                  }
                  control={Input}
                  value={templateNew}
                  placeholder="Create New"
                  onChange={handleChangeName}
                  onKeyDown={handleKeyPress}
                />
              </Form.Group>
            </Form>
            {workflowConfigurationStore.WorkflowConfiguration
              .editClickedTemplate === false ? (
              <div className="workflow-input-div">
                {commonStore.filterModeTwo?.includes('SWB08') ? (
                  <></>
                ) : (
                  <Button
                    primary
                    onClick={handleClone}
                    className="workflow-input-button"
                    disabled={
                      commonStore.filterModeZero?.includes('SWB08') ||
                      errorType !== ''
                    }
                  >
                    {' '}
                    Clone{' '}
                  </Button>
                )}

                {/* <Button primary onClick={handleClone} className="workflow-input-button"   disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB08")?true:false || errorType==='SameName'||errorType==='EmptyName'?true:false}> Clone </Button> */}

                {commonStore.filterModeTwo?.includes('SWB06') ? (
                  <></>
                ) : (
                  <Button
                    color="green"
                    floated="right"
                    onClick={addNewTemplate}
                    className="workflow-input-button"
                    disabled={
                      commonStore.filterModeZero?.includes('SWB06') ||
                      errorType !== ''
                    }
                  >
                    Add New
                  </Button>
                )}

                {/* <Button color="green" floated='right' onClick={addNewTemplate}  className="workflow-input-button" disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB06")?true:false || errorType==='SameName'||errorType==='EmptyName'?true:false}>Add New</Button> */}
              </div>
            ) : (
              <div className="workflow-input-div">
                <Button
                  secondary
                  className="workflow-input-button"
                  onClick={() => handleSaveEdited('cancel')}
                >
                  {' '}
                  Cancel
                </Button>
                <Button
                  primary
                  floated="right"
                  onClick={() => handleSaveEdited('edit')}
                  className="workflow-input-button"
                  disabled={errorType !== ''}
                >
                  Save
                </Button>
              </div>
            )}
          </Segment>
        </Card>
        {workflowConfigurationStore.WorkflowConfiguration.showTaskCard ? (
          <WorkflowTasks />
        ) : null}
      </Grid>
    </div>
  );
}

export default observer(WorkflowTemplates);
